<template>
  <div class="shipping-instructions-width-add-header">

    <Button
      :size="17"
      :width="35"
      color="#0d70cc"
      colorText="#ffffff"
      icon="fa fa-file-medical"
      tooltip="Nuevo Shipping Instruction"
      round
      traslate
      @click.native="openModal('modalAddShippingInstruction')"
    />

    <ui-modal
      @close="ActionSetZindexModal(false)"
      ref="modalAddShippingInstruction"
      title="Nuevo Shipping Instruction"
      class="modal-agregar-shipping-instruction"
    >
      <shipping-form-component 
        :closeModal="closeModalRef"
        showButtonRecharge
      />
    </ui-modal>
  </div>
</template>

<script>

// 
import { mapActions } from "vuex";

// Components
import UiModal from "keen-ui/src/UiModal";
import Button from "../../common/Button";
import ShippingFormComponent from '../../common/forms/ShippingFormComponent';

// Custom Components 


export default {
  data() {  
    return {

    }
  },
  components: {
    UiModal,
    Button,
    ShippingFormComponent 
  },

  methods: {
    ...mapActions("shippinginstructions", [
      "actionSetDataDataShippingInstructionPorEnviar"
    ]),
    ...mapActions(["ActionSetZindexModal"]),

    openModal(ref) {
      this.$refs[ref].open();
      this.ActionSetZindexModal(true);
    },

    closeModalRef(){
      this.closeModal("modalAddShippingInstruction");
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

  },
};
</script>

<style>

.shipping-instructions-width-add-header .ui-modal--size-normal>.ui-modal__wrapper>.ui-modal__container {
  width: 81% !important;
}

</style>
